import _upperFirst from "lodash/upperFirst";
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import classnames from 'classnames';
import injectStyles from '../jss';
import styles from './Heading.jss';
export var Heading = /*#__PURE__*/
function (_React$Component) {
  _inherits(Heading, _React$Component);
  function Heading() {
    _classCallCheck(this, Heading);
    return _possibleConstructorReturn(this, _getPrototypeOf(Heading).apply(this, arguments));
  }
  _createClass(Heading, [{
    key: "render",
    value: function render() {
      var _classnames;
      var _this$props = this.props,
        centered = _this$props.centered,
        children = _this$props.children,
        classes = _this$props.classes,
        classNameProp = _this$props.className,
        id = _this$props.id,
        Element = _this$props.kind,
        noMargin = _this$props.noMargin,
        style = _this$props.style;
      var text = typeof children === 'string' ? React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: children
        }
      }) : children;
      var className = classnames(classes.base, classes["kind".concat(_upperFirst(Element))], (_classnames = {}, _defineProperty(_classnames, classes.centered, centered), _defineProperty(_classnames, classes.noMargin, noMargin), _classnames), classNameProp);
      return React.createElement(Element, {
        id: id,
        className: className,
        style: style
      }, text);
    }
  }]);
  return Heading;
}(React.Component);
_defineProperty(Heading, "styleRoot", 'Heading');
_defineProperty(Heading, "defaultProps", {
  centered: false,
  kind: 'h1',
  noMargin: false
});
export default injectStyles(styles)(Heading);